enum ChallengeLeagueTags {
  BOOTCAMP = "BOOTCAMP",
  BRONZE = "BRONZE_LEAGUE",
  SILVER = "SILVER_LEAGUE",
  GOLD = "GOLD_LEAGUE",
  CHAMPIONS = "CHAMPIONS_LEAGUE",
  DRILL = "DRILL",
  ALL = "ALL",
  DEMO = "DEMO",
  QA = "QA",
  DEVELOPMENT = "DEVELOPMENT",
  BETA_CONTENT = "BETA_CONTENT",
}

export default ChallengeLeagueTags;
